import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

// total_body_water, dry_lean_mass, body_fat_mass, pbf, smm, bmi, weight, right_arm, left_arm, trunk, right_leg, left_leg

const total_body_water_color= "#c22a2a";
const dry_lean_mass_color   = "#6621c4";
const body_fat_mass_color   = "#2e78e7";
const pbf_color             = "#bf56fc";
const smm_color             = "#56e7fc";
const bmi_color             = "#fc9856";
const weight_color          = "#fc56a0"
const right_arm_color       = "#c91bde";
const left_arm_color        = "#1bc9de";
const trunk_color           = "#dea91b";
const right_leg_color       = "#3da211";
const left_leg_color        = "#666666";

const STRENGTH_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Total Body Water',  data: "total_body_water_data", color: total_body_water_color, strokeWidth: 14},
    {title: 'Dry Lean Mass', data: "dry_lean_mass_data", color: dry_lean_mass_color, strokeWidth: 14 },
    {title: 'Body Fat Mass', data: "body_fat_mass_data", color: body_fat_mass_color, strokeWidth: 14 },
    {title: 'PBF', data: "pbf_data", color: pbf_color, strokeWidth: 14 },
    {title: 'SMM', data: "smm_data", color: smm_color, strokeWidth: 14 },
    {title: 'BMI', data: "bmi_data", color: bmi_color, strokeWidth: 14 },
    {title: 'Weight', data: "weight_data", color: weight_color, strokeWidth: 14 },
    {title: 'Right Arm', data: "right_arm_data", color: right_arm_color, strokeWidth: 14 },
    {title: 'Left Arm', data: "left_arm_data", color: left_arm_color, strokeWidth: 14 },
    {title: 'Trunk', data: "trunk_data", color: trunk_color, strokeWidth: 14 },
    {title: 'Right Leg', data: "right_leg_data", color: right_leg_color, strokeWidth: 14 },
    {title: 'Left Leg', data: "left_leg_data", color: left_leg_color, strokeWidth: 14 }
];

var total_body_water_data   = [];
var dry_lean_mass_data      = [];
var body_fat_mass_data      = [];
var pbf_data                = [];
var smm_data                = [];
var bmi_data                = [];
var weight_data             = [];
var right_arm_data          = [];
var left_arm_data           = [];
var trunk_data              = [];
var right_leg_data          = [];
var left_leg_data           = [];

var legend1_title  = "Total Body Water";
var legend2_title  = "Dry Lean Mass";
var legend3_title  = "Body Fat Mass";
var legend4_title  = "PBF";
var legend5_title  = "SMM";
var legend6_title  = "BMI";
var legend7_title  = "Weight";
var legend8_title  = "Right Arm";
var legend9_title  = "Left Arm";
var legend10_title = "Trunk";
var legend11_title = "Right Leg";
var legend12_title = "Left Leg";

export default class AssessInBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "InBody Assessment",
            max_y_val: 0,
            min_y_val: 0,
            all_data: true,
            yAxisLabel: "",
            crosshairPreValues:      [],
        }
    }

    componentDidMount() {
        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        total_body_water_data = [];
        dry_lean_mass_data    = [];
        body_fat_mass_data    = [];
        pbf_data              = [];
        smm_data        = [];
        bmi_data              = [];
        weight_data           = [];
        right_arm_data        = [];
        left_arm_data         = [];
        trunk_data            = [];
        right_leg_data        = [];
        left_leg_data         = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsInBody;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.inbody;
            var ctr = 0;
            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var total_body_water = data[key].total_body_water;
                var dry_lean_mass    = data[key].dry_lean_mass
                var body_fat_mass    = data[key].body_fat_mass;
                var pbf              = data[key].pbf;
                var smm              = data[key].smm;
                var bmi              = data[key].bmi;
                var weight           = data[key].weight;
                var right_arm        = data[key].right_arm;
                var left_arm         = data[key].left_arm;
                var trunk            = data[key].trunk;
                var right_leg        = data[key].right_leg;
                var left_leg        = data[key].left_leg;
                var date_created     = data[key].date_created;
                var date             = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                total_body_water_data.push({"x": date, "y": total_body_water});
                dry_lean_mass_data.push({"x": date, "y": dry_lean_mass});
                body_fat_mass_data.push({"x": date, "y": body_fat_mass});
                pbf_data.push({"x": date, "y": pbf});
                smm_data.push({"x": date, "y": smm});
                bmi_data.push({"x": date, "y": bmi});
                weight_data.push({"x": date, "y": weight});
                right_arm_data.push({"x": date, "y": right_arm});
                left_arm_data.push({"x": date, "y": left_arm});
                trunk_data.push({"x": date, "y": trunk});
                right_leg_data.push({"x": date, "y": right_leg});
                left_leg_data.push({"x": date, "y": left_leg});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(total_body_water, dry_lean_mass, body_fat_mass, pbf, smm, bmi, weight, right_arm, left_arm, trunk, right_leg, left_leg)
            }

            var max_y_val = Math.max(...max_array) + 35;

            this.setState({
                report_data: data.length,
                all_data: true,
                right_leg_data: right_leg_data,
                left_leg_data: left_leg_data,
                total_body_water_data: total_body_water_data,
                dry_lean_mass_data: dry_lean_mass_data,
                body_fat_mass_data: body_fat_mass_data,
                pbf_data: pbf_data,
                smm_data: smm_data,
                bmi_data: bmi_data,
                weight_data: weight_data,
                right_arm_data: right_arm_data,
                left_arm_data: left_arm_data,
                trunk_data: trunk_data,
                max_y_val: max_y_val,
                min_y_val: 0 // reset min y val
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXPreWorkout = (value, {index}) => {
        var x   = total_body_water_data[index].y;
        var x2  = total_body_water_data[index].x;
        var y1  = dry_lean_mass_data[index].y;
        var y2  = body_fat_mass_data[index].y;
        var y3  = pbf_data[index].y;
        var y4  = smm_data[index].y;
        var y5  = bmi_data[index].y;
        var y6  = weight_data[index].y;
        var y7  = right_arm_data[index].y;
        var y8  = left_arm_data[index].y;
        var y9  = trunk_data[index].y;
        var y10 = right_leg_data[index].y;
        var y11 = left_leg_data[index].y;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7,
                        crossHairY8: y8,
                        crossHairY9: y9,
                        crossHairY10: y10,
                        crossHairY11: y11,
                      });
    };

    getMaxYAxisVals (data) {
        var arr = []
        var data2 = eval(data); // get actual vals of array

        for(var key in data2)
            arr.push(data2[key].y);

        var max_y_val = Math.max(...arr) + 15;
        var min_y_val = Math.min(...arr) - 15;

        // Don't let min_y_val go below 0
        if(min_y_val < 0) min_y_val = 0;

        var maxMinObj = {};
        maxMinObj.max_y_val = max_y_val;
        maxMinObj.min_y_val = min_y_val;

        return maxMinObj;
    }

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "total_body_water_data")    dataset = {"total_body_water_data":total_body_water_data, yAxisLabel: "Lbs"};
            else if(data === "dry_lean_mass_data")  dataset = {"dry_lean_mass_data":dry_lean_mass_data, yAxisLabel: "Lbs"};
            else if(data === "body_fat_mass_data")  dataset = {"body_fat_mass_data":body_fat_mass_data, yAxisLabel: "Lbs"};
            else if(data === "pbf_data")            dataset = {"pbf_data": pbf_data, yAxisLabel: "Percentage"};
            else if(data === "smm_data")            dataset = {"smm_data": smm_data, yAxisLabel: "Lbs"};
            else if(data === "bmi_data")            dataset = {"bmi_data": bmi_data, yAxisLabel: "Score"};
            else if(data === "weight_data")         dataset = {"weight_data": weight_data, yAxisLabel: "Lbs"};
            else if(data === "right_arm_data")      dataset = {"right_arm_data": right_arm_data, yAxisLabel: "Lbs"};
            else if(data === "left_arm_data")       dataset = {"left_arm_data": left_arm_data, yAxisLabel: "Lbs"};
            else if(data === "trunk_data")          dataset = {"trunk_data": trunk_data, yAxisLabel: "Lbs"};
            else if(data === "right_leg_data")      dataset = {"right_leg_data": right_leg_data, yAxisLabel: "Lbs"};
            else if(data === "left_leg_data")       dataset = {"left_leg_data": left_leg_data, yAxisLabel: "Lbs"};

            var maxMinObj = this.getMaxYAxisVals(data);
            var max_y_val = maxMinObj.max_y_val;
            var min_y_val = maxMinObj.min_y_val;

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                total_body_water_data: [],
                dry_lean_mass_data: [],
                body_fat_mass_data: [],
                pbf_data: [],
                smm_data: [],
                bmi_data: [],
                weight_data: [],
                right_arm_data: [],
                left_arm_data: [],
                trunk_data: [],
                right_leg_data: [],
                left_leg_data: [],
                max_y_val: max_y_val,
                min_y_val: min_y_val
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "60%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3} %</span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5} score</span>
                    </span>
                    <span style={{display:"inline-block", width: "40%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend10_title }: {this.state.crossHairY9} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend11_title }: {this.state.crossHairY10} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend12_title }: {this.state.crossHairY11} lbs</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var value;
        var measure = "lbs."
        if(dataset == "total_body_water_data") {
            legend    = legend1_title;
            value     = this.state.crossHairX;
        } else if(dataset == "dry_lean_mass_data") {
            legend    = legend2_title;
            value     = this.state.crossHairY1;
        } else if(dataset == "body_fat_mass_data") {
            legend    = legend3_title;
            value     = this.state.crossHairY2;
        } else if(dataset == "pbf_data") {
            legend    = "Percent Body Fat"; //legend4_title;
            value     = this.state.crossHairY3;
            measure   = "%"
        } else if(dataset == "smm_data") {
            legend    = "Skeletal Muscle Mass"; //legend5_title;
            value     = this.state.crossHairY4;
        } else if(dataset == "bmi_data") {
            legend    = "Body Mass Index"; //legend6_title;
            value     = this.state.crossHairY5;
            measure   = "score"
        } else if(dataset == "weight_data") {
            legend    = legend7_title;
            value     = this.state.crossHairY6;
        } else if(dataset == "right_arm_data") {
            legend    = legend8_title;
            value     = this.state.crossHairY7;
        } else if(dataset == "left_arm_data") {
            legend    = legend9_title;
            value     = this.state.crossHairY8;
        } else if(dataset == "trunk_data") {
            legend    = legend10_title;
            value     = this.state.crossHairY9;
        } else if(dataset == "right_leg_data") {
            legend    = legend11_title;
            value     = this.state.crossHairY10;
        } else if(dataset == "left_leg_data") {
            legend    = legend12_title;
            value     = this.state.crossHairY11;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { value } { measure }</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var max_y_val = this.state.max_y_val;
        var min_y_val = this.state.min_y_val;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 260;
        if(all_data) {
            tooltip_width = 430;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="child" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[min_y_val, max_y_val]}
                                                     onMouseLeave = {this.onMouseLeavePreWorkout}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                     <YAxis title={this.state.yAxisLabel} {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.total_body_water_data}           size={2.5} color={total_body_water_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.dry_lean_mass_data}          size={2.5} color={dry_lean_mass_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.body_fat_mass_data}        size={2.5} color={body_fat_mass_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.pbf_data}   size={2.5} color={pbf_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.smm_data}        size={2.5} color={smm_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.bmi_data}      size={2.5} color={bmi_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.weight_data}              size={2.5} color={weight_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.right_arm_data}     size={2.5} color={right_arm_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.left_arm_data}             size={2.5} color={left_arm_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.trunk_data}               size={2.5} color={trunk_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.right_leg_data}            size={2.5} color={right_leg_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.left_leg_data}            size={2.5} color={left_leg_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <Crosshair values={this.state.crosshairPreValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={STRENGTH_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessInBody.js